import { ApplicationConfig } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { provideRouter, Route, Router, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRouter } from './app-router.service';
import { AppRouteConfig, routes } from './app.routes';
import localeFr from '@angular/common/locales/fr';
import localeGb from '@angular/common/locales/en-GB';

const mapAppRoute = (key: string, config: AppRouteConfig): Route => {
  const { url, needAuth, children, ...rest } = config;

  const route: Route = { ...rest, data: { name: key } };
  if (children && children.length > 0) {
    route.children = children.map((child, index) => mapAppRoute(`${key}-child-${index}`, child));
  }

  return route;
};

export const routesToLoad = Object.entries(routes).map(([key, config]) => mapAppRoute(key, config));

registerLocaleData(localeFr);
registerLocaleData(localeGb);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routesToLoad, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideAnimations(),
    provideHttpClient(),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    provideOAuthClient(),
    { provide: OAuthStorage, useFactory: (): OAuthStorage => localStorage },
    { provide: Router, useClass: AppRouter },
    provideTranslateService({
      // configure loader
      loader: provideTranslateHttpLoader({
        prefix: 'assets/i18n/',
        suffix: '.json',
      }),
    }),
  ],
};
